import orderBy from 'lodash/orderBy';

import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

import format from '@r1-frontend/ui-react/components/costs/Cost/format';
import { IOptionVariant } from '@r1-frontend/ui-react/components/OptionList';
import { MDASH, NBSP } from '@r1-frontend/ui-react/tokens/symbols';

export const getCreditOptions = (creditConditions: ICreditCondition[]): IOptionVariant[] => {
    const variants: IOptionVariant[] = orderBy(creditConditions, ['duration'], ['asc'])
            .map(({ duration, cost, pay }) => {
                return {
                    id: duration,
                    label: `Полная стоимость ${NBSP}${MDASH} ${format(cost)}`,
                    value: pay,
                    valueStr: `${format(pay, { monthly: true })} на ${duration} мес.`,
                };
            });
    return variants;
};
